var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87902 13.6845H8.295C8.37928 13.6845 8.47199 13.6424 8.48885 13.575L12.0456 8.2145C12.0878 8.12178 12.1552 8.10493 12.2395 8.10493L16.2851 8.10493C16.9763 8.10493 17.5325 7.54865 17.5325 6.85752C17.5325 6.16639 16.9763 5.61012 16.2851 5.61012L12.1046 5.61012C12.0204 5.61012 11.9529 5.59326 11.9108 5.50055L8.22757 0.13165C8.16014 0.064223 8.118 0.022081 8.03372 0.022081L6.55032 0.0389378C6.38175 0.0389378 6.24689 0.207506 6.31432 0.359217L8.22757 5.28984C8.295 5.44155 8.16014 5.61012 7.99157 5.61012L3.55823 5.61012C3.47395 5.61012 3.38123 5.56797 3.36438 5.50055L2.20126 3.73058C2.15911 3.63787 2.09169 3.62101 2.0074 3.62101L1.1477 3.62101C0.979137 3.62101 0.861139 3.77272 0.911709 3.94129L1.67027 6.11582C1.64498 6.14111 1.67027 6.16639 1.67027 6.20011L1.67027 7.44751C1.67027 7.49808 1.67027 7.49808 1.65341 7.51494L0.920137 9.74847C0.85271 9.90018 0.987565 10.0687 1.15613 10.0687H1.88098C1.96526 10.0687 2.05797 10.0266 2.07483 9.95918L3.25481 8.17235C3.29695 8.07964 3.36438 8.06278 3.44866 8.06278L8.15171 8.06278C8.32028 8.06278 8.43828 8.21449 8.38771 8.38306L6.66831 13.339C6.59246 13.5328 6.71046 13.6845 6.87902 13.6845Z",
    fill: "#27499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneSm);
export default __webpack_public_path__ + "static/media/plane-sm.ce21ab1e6b614020882e98e3ba8717a5.svg";
export { ForwardRef as ReactComponent };